<div class="dropdown-wrap">
  <ng-content select=".source"></ng-content>
  <ng-container *ngIf="showDropdown">
    <div class="dropdown-bg" (click)="onDismiss()"></div>

    <div [class.start-0]="alignContent === Align.Start" [class.end-0]="alignContent === Align.End"
      class="dropdown-content dropdown-covered">
      <ng-content class=".content"></ng-content>
    </div>
  </ng-container>
</div>
